import React, { useState } from 'react';

interface EmptySeatProps {
  onDrop: (memberId: number) => void;
}

export function EmptySeat({ onDrop }: EmptySeatProps) {
  const [over, setOver] = useState(false);

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setOver(false);
    const memberId = Number(e.dataTransfer.getData('text/plain'));
    if (!isNaN(memberId)) onDrop(memberId);
  };

  return (
    <div
      onDragOver={handleDragOver}
      onDragEnter={() => setOver(true)}
      onDragLeave={() => setOver(false)}
      onDrop={handleDrop}
      className={`flex items-center justify-center rounded-xl border-2 border-dashed px-3 py-4 transition-colors ${
        over
          ? 'border-blueberry-500 bg-blueberry-50 dark:bg-blueberry-900/20'
          : 'border-nightshade-200 dark:border-nightshade-700'
      }`}
    >
      <span className="text-[10px] text-nightshade-400 dark:text-nightshade-500 uppercase tracking-wide">Empty</span>
    </div>
  );
}
